import {
  Box,
  Flex,
  IconButton,
  InputDescription,
  InputGroup,
  InputGroupLabel,
} from '@fullstory/components';
import { intl } from '@fullstory/intl';
import React, { useCallback } from 'react';
import { URLRuleAutoComplete } from '@fullstory/pages-shared/components/URLRuleAutoComplete';

const FRAGMENT_SIGNIFIER = '#';

interface URLRuleFragmentProps {
  value: string;
  error?: string;
  onChange: (value: string) => void;
  onClear: () => void;
  onFocus?: () => void;
  getSuggestions: (value: string) => Promise<string[]>;
}

export const URLRuleFragment: React.FC<URLRuleFragmentProps> = ({
  value,
  error,
  onChange: _onChange,
  onClear,
  onFocus,
  getSuggestions,
}) => {
  // if user or auto-complete input starts with FRAGMENT_SIGNIFIER, remove it as it is built in to the input
  const onChange = useCallback(
    (value: string) => {
      _onChange(value.startsWith(FRAGMENT_SIGNIFIER) ? value.slice(1) : value);
    },
    [_onChange],
  );

  return (
    <Box>
      <Flex justifyContent="stretch" alignItems="center" gap={4}>
        <InputGroup style={{ flexGrow: 1 }}>
          <InputGroupLabel>{FRAGMENT_SIGNIFIER}</InputGroupLabel>
          <URLRuleAutoComplete
            value={value}
            onChange={onChange}
            invalid={!!error}
            getSuggestions={getSuggestions}
            placeholder={intl.formatMessage({
              defaultMessage: 'Enter fragment, e.g. "anchor"',
              id: 'ccYWAz',
            })}
            testId="auto-complete-fragment"
            autoFocusInput={!value}
            onFocus={onFocus}
          />
        </InputGroup>
        <IconButton
          iconName="clear"
          title={intl.formatMessage({ defaultMessage: 'Remove fragment', id: 'f0kDUc' })}
          onClick={onClear}
        />
      </Flex>
      {error && <InputDescription invalid description={error} />}
    </Box>
  );
};
